import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';

import { UserRoleService } from '../../../../services/user-role.service';
import { TaskUtilityService } from '../../../utility/task-utility.service';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import * as fromTask from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { PetitionerService } from '../../../../services/petitioner.service';
import { ToastrService } from 'ngx-toastr';
import { SubTask, TaskHeaderSummaryDetail } from 'app-models';
import { DEPENDENT_VISAS } from 'app-models';
import { take, takeUntil } from 'rxjs/operators';
import { getSubTaskStatus } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
@Component({
  selector: 'app-task-header',
  templateUrl: './task-header.component.html',
  styleUrls: ['./task-header.component.scss']
})
export class TaskHeaderComponent implements OnInit, OnDestroy {
  // superTaskDetails: SuperTask;
  superTaskDetails: any;
  avatarSrc = '';
  superTaskId: number = null;
  createdUserName;
  createdDate;
  taskLabel = '';
  userType = '';
  companyId = '';
  beneCompany = '';
  beneficiaryId = '';
  beneficiaryEmployeeId = 0;
  summaryDetailsList: TaskHeaderSummaryDetail[];
  SubTaskTypeList: string[];
  applicantNameList = [];
  primaryApplicant: string;
  isDependentVisa: boolean;
  isBeneficiaryVisible: boolean;
  subTaskList: SubTask[];
  isImmigrationVisiable = false;
  observableSubscription$ = new Subject();

  constructor(
    private router: Router,
    private userRoleService: UserRoleService,
    private utilityService: TaskUtilityService,
    private store: Store<fromTask.State>,
    private petitionerService: PetitionerService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.userType = sessionStorage.getItem('userTypeRole');

    this.avatarSrc = (sessionStorage.getItem('avatar') !== 'undefined') ? `data:image/jpeg;base64,${sessionStorage.getItem('avatar')}` : '';
    this.userRoleService.profilePicUpdated
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((noUpdateFlag: boolean) => {
        if (!noUpdateFlag) {
          this.avatarSrc = (sessionStorage.getItem('avatar') !== 'undefined') ?
            `data:image/jpeg;base64,${sessionStorage.getItem('avatar')}` : '';
        }
      });
    // ------------------- //
    if (this.summaryDetailsList) {
      this.summaryDetailsList.splice(0, this.summaryDetailsList.length);
    } else {
      this.summaryDetailsList = [];
    }
    combineLatest([
      this.store.select(fromTask.getSuperTask),
      this.store.select(fromTask.getSubTaskTypeList),
      this.store.select(fromTask.getSubTaskList),
    ])
      .pipe(take(1))
      .subscribe(([superTask, SubTaskTypeList, subTaskList]) => {
        this.isBeneficiaryVisible = superTask['isBeneficiaryVisible'];
        if (subTaskList && subTaskList.length > 0) {
          if (subTaskList[0].superTaskTypeCode === 'IMMPET') {
            this.isImmigrationVisiable = true;
          }
        }

        if (this.summaryDetailsList) {
          this.summaryDetailsList.splice(0, this.summaryDetailsList.length);
        } else {
          this.summaryDetailsList = [];
        }
        if (SubTaskTypeList.length && superTask) {
          this.SubTaskTypeList = SubTaskTypeList;
          this.superTaskDetails = superTask;
          sessionStorage.setItem('taskID', this.superTaskDetails?.superTaskId);
          this.isDependentVisa =
            DEPENDENT_VISAS.includes(this.superTaskDetails.visaType?.code) ||
            ['K1', 'K3', 'U1','UD','UQ'].includes(this.superTaskDetails.visaType?.code);
            const jsonInput = this.superTaskDetails.jsonInput ? JSON.parse(this.superTaskDetails.jsonInput) : null;
          if (this.SubTaskTypeList.includes('PETITION') || this.SubTaskTypeList.includes('RFE') || this.SubTaskTypeList.includes('DS160')  || this.SubTaskTypeList.includes('I129EFILING') || (this.superTaskDetails?.visaType && this.SubTaskTypeList.includes('PWDEFILE'))) {
            if (this.superTaskDetails.visaType) {
              const visatype: TaskHeaderSummaryDetail = {
                name: 'Visa Type',
                value: this.superTaskDetails.visaType ? this.superTaskDetails.visaType.name : ''
              };
              const petitiontype: TaskHeaderSummaryDetail = {
                name: 'Petition Type',
                value: this.superTaskDetails.petitionType ? this.superTaskDetails.petitionType.name : ''
              };
              const status: TaskHeaderSummaryDetail = {
                name: 'Status',
                value: this.superTaskDetails.status ? this.superTaskDetails.status.name : ''
              };
              if ((this.superTaskDetails.visaType && this.isDependentVisa)) {
                // const h4applicants: TaskHeaderSummaryDetail = {
                //   name: 'H4-Applicants',
                //   value: this.superTaskDetails.jsonInput ? this.superTaskDetails.jsonInput.applicantsList : ''
                // };

                if (['K1', 'K3','UQ'].includes(this.superTaskDetails.visaType.code) || this.superTaskDetails.petitionType.code === 'EAD') {
                  if (jsonInput && jsonInput.primaryApplicant) {
                    this.applicantNameList = [];
                    this.applicantNameList.push(jsonInput.primaryApplicant);
                  }
                } else {
                  this.applicantNameList = jsonInput && jsonInput.applicantsList &&
                    jsonInput.applicantsList.length > 0 ? jsonInput.applicantsList : [];
                }

                // if(this.superTaskDetails.petitionType.code === 'EAD' && jsonInput && jsonInput.primaryApplicant){
                //   this.applicantNameList = [];
                //   this.applicantNameList.push(jsonInput.primaryApplicant);
                // }else{
                //   this.applicantNameList = jsonInput && jsonInput.applicantsList &&  jsonInput.applicantsList.length > 0 ? jsonInput.applicantsList : [];
                // }

              }
              this.summaryDetailsList.push(visatype, petitiontype, status);
            } else {
              const catergory: TaskHeaderSummaryDetail = {
                name: 'Category',
                value: this.superTaskDetails.immigrationCategory ? this.superTaskDetails.immigrationCategory.name : ''
              };
              const classification: TaskHeaderSummaryDetail = {
                name: 'Classification',
                value: this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : ''
              };
              const status: TaskHeaderSummaryDetail = {
                name: 'Status',
                value: this.superTaskDetails.status ? this.superTaskDetails.status.name : ''
              };

              this.summaryDetailsList.push(catergory, classification, status);
            }


          } else if (this.SubTaskTypeList.includes('PERM') || this.SubTaskTypeList.includes('I140') || this.SubTaskTypeList.includes('I485') || this.SubTaskTypeList.includes('DS260') || (this.superTaskDetails?.immigrationCategory && this.SubTaskTypeList.includes('PWDEFILE') || this.SubTaskTypeList.includes('I130ONLINEEFILE'))) {
            //  : Employment Based | Classification : EB-2 | Status: PWD In-Process
            const catergory: TaskHeaderSummaryDetail = {
              name: 'Category',
              value: this.superTaskDetails.immigrationCategory ? this.superTaskDetails.immigrationCategory.name : ''
            };
            const classification: TaskHeaderSummaryDetail = {
              name: 'Classification',
              value: this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : ''
            };
            const status: TaskHeaderSummaryDetail = {
              name: 'Status',
              value: this.superTaskDetails.status ? this.superTaskDetails.status.name : ''
            };
            if(['F1','F2A','F2B','F3','F4','IR1','IR2','IR5','ONLINEIMMVISAREG'].includes(this.superTaskDetails.immigrationClassification?.code)){
              this.applicantNameList = jsonInput && jsonInput.applicantsList &&
              jsonInput.applicantsList.length > 0 ? jsonInput.applicantsList : [];
            }
            this.summaryDetailsList.push(catergory, classification, status);
          } else if (this.SubTaskTypeList.includes('I130')) {
            const applicant: TaskHeaderSummaryDetail = {
              name: 'Applicant',
              value: this.superTaskDetails.familyFirstName && this.superTaskDetails.familyLastName ? `${this.superTaskDetails.familyFirstName} ${this.superTaskDetails.familyLastName}` : ''
            };
            const category: TaskHeaderSummaryDetail = {
              name: 'Category',
              value:
                this.superTaskDetails.immigrationCategory &&
                  this.superTaskDetails.immigrationCategory.name ?
                  this.superTaskDetails.immigrationCategory.name : ''
            };
            const classification: TaskHeaderSummaryDetail = {
              name: 'Classification',
              value: this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.name : ''
            };
            const status: TaskHeaderSummaryDetail = {
              name: 'Status',
              value: this.superTaskDetails.status ? this.superTaskDetails.status.name : ''
            };
            this.summaryDetailsList.push(applicant, category, classification, status);
          }

          this.populateDetails();
        }
      });
    
      this.store.select(getSubTaskStatus).pipe(takeUntil(this.observableSubscription$)).subscribe((res: any)=>{
        if (this.summaryDetailsList.length && res?.value){
          const status: TaskHeaderSummaryDetail = {
            name: 'Status',
            value: ['Approved','Denied'].includes(res.value) ? `Petition ${res.value}` : res.value
          };
          const prevStatus = this.summaryDetailsList.findIndex((x)=> x.name === 'Status');
          this.summaryDetailsList[prevStatus] = status;
        }
      });
  }

  getTaskBeneficiarySummery() {
    this.petitionerService.getTaskBeneficiarySummery(this.isBeneficiaryVisible, this.superTaskDetails.superTaskId)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (response.status === 200) {
          this.toastr.success(response.message, 'Success');
          // this.isBeneficiaryVisible = response
        }
      });
  }

  populateDetails() {
    if (this.superTaskDetails !== undefined) {
      this.superTaskId = this.superTaskDetails.superTaskId;
      this.taskLabel = (this.superTaskId) ? `Task ID - ${this.superTaskId}` : `Task`;
      this.companyId = String(this.superTaskDetails.companyId);
      this.beneCompany = String((this.userType === 'Attorney' || this.userType === 'Petitioner') ?
        this.superTaskDetails.companyId : this.superTaskDetails.companyName);
      this.beneficiaryId = this.SubTaskTypeList.includes('I130') ?
        String(this.superTaskDetails.sponsorId) : String(this.superTaskDetails.beneficiaryId);
      sessionStorage.setItem('beneficiaryId', this.beneficiaryId);
      sessionStorage.setItem('selectedCompanyId', this.companyId);
    }
  }


  viewcompany() {
    const id = !!this.companyId ? this.companyId : this.beneCompany;
    sessionStorage.setItem('viewModeCompanyId', `${id}`);
    sessionStorage.setItem('company-viewMode', 'true');
    let url;
    if (this.userType === RolesRouteMap.PETITIONER) {
      url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/companies/petitioner/company/details`;
    }
    if (this.userType === RolesRouteMap.ATTORNEY) {
      url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/client-companies/petitioner/company/details`;
    }
    this.router.navigate([]).then(() => {
      window.open(url, '_blank');
    });
  }

  viewbeneficiaries() {
    const id = this.beneficiaryId;
    sessionStorage.setItem('listBeneficiaryId', `${id}`);
    sessionStorage.setItem('bene-profile-viewMode', 'true');
    sessionStorage.removeItem('bene-update-profile');
    let url;
    if (this.userType === RolesRouteMap.PETITIONER) {
      url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile/profile-details`;
    }

    if (this.userType === RolesRouteMap.ATTORNEY) {
      url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`;
    }
    this.router.navigate([]).then(() => {
      window.open(url, '_blank');
    });

  }

  ngOnDestroy() {
    this.utilityService.setTaskId(null);
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

}
